module.exports = __webpack_public_path__ + "static/media/car-woman.6f78a4c7.png";